const moment = require('moment')

/**
 * Format date
 * @param dateString
 * @param format
 * @param isUTC
 * @returns {string}
 */
export function formatDate (dateString, format, isUTC) {
  if (!dateString) {
    return '-'
  }
  const fromFormat = ['MM/DD/YY', 'YYYY-MM-DD hh:mm:ss']

  const date = isUTC ? moment.utc(dateString, fromFormat) : moment(dateString, fromFormat)
  return date.isValid() ? format ? date.format(format) : date : '-'
}
